<template>
  <div class="page_bd Aboutus-area">
    <secBanner></secBanner>
    <div class="breadcrumb-nav">
      <div class="container">
        您现在的位置：
        <router-link to="/">首页</router-link>
        >
        <router-link :to="{ path: '/aboutus', query: { tab: 0 } }"
          >关于我们</router-link
        >
        >
        <span>{{
          activeIndex == 0
            ? "公司概况"
            : activeIndex == 1
            ? "企业文化"
            : "资质荣誉"
        }}</span>
      </div>
    </div>
    <div class="container content-area">
      <div class="tabs">
        <div
          class="tab"
          :class="{ active: activeIndex == '0' }"
          @click="changeTab(0)"
        >
          公司概况
        </div>
        <div
          class="tab"
          :class="{ active: activeIndex == '1' }"
          @click="changeTab(1)"
        >
          企业文化
        </div>
        <div
          class="tab"
          :class="{ active: activeIndex == '2' }"
          @click="changeTab(2)"
        >
          资质荣誉
        </div>
        <!-- <router-link
          class="tab"
          :class="{ active: activeIndex == '0' }"
          :to="{ path: '/aboutus', query: { tab: 0 } }"
          >公司概况</router-link
        >
        <router-link
          class="tab"
          :class="{ active: activeIndex == '1' }"
          :to="{ path: '/aboutus', query: { tab: 1 } }"
          >企业文化</router-link
        >
        <router-link
          class="tab"
          :class="{ active: activeIndex == '2' }"
          :to="{ path: '/aboutus', query: { tab: 2 } }"
          >资质荣誉</router-link
        > -->
      </div>
      <div class="lead">
        {{
          activeIndex == 0
            ? "公司概况"
            : activeIndex == 1
            ? "企业文化"
            : "资质荣誉"
        }}
      </div>
      <div class="panels">
        <div class="panel" v-if="activeIndex == 0">
          <div v-html="articleDetail"></div>
        </div>
        <div class="panel" v-if="activeIndex == 1">
          <div v-html="articleDetail"></div>
        </div>
        <div class="panel" v-if="activeIndex == 2">
          <ul class="honor">
            <li v-for="(item, index) in dataList" :key="index">
              <!-- <div class="img"></div> 'fill', 'contain', 'cover', 'none', 'scale-down' -->
              <el-image
                class="img"
                :src="$imgBaseUrl + item.article_img"
                :preview-src-list="srcList"
                fit="fill"
              ></el-image>
              <div class="title ellipsis">{{ item.title }}</div>
            </li>
          </ul>
          <pagination
            :total="total"
            :page.sync="listQuery.page"
            :limit.sync="listQuery.limit"
            layout="total, prev, pager, next, jumper"
            :hide-on-single-page="total < listQuery.limit"
            @pagination="getArticle"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import secBanner from "@/components/assembly/sec-banner";
import Pagination from "@/components/assembly/pagination";
// import Image from 'element-ui'
// import 'viewerjs/dist/viewer.css'
// import Viewer from 'v-viewer'
// import Vue from 'vue'
// Vue.use(Viewer)
export default {
  data() {
    return {
      activeIndex: this.$route.query.tab,
      total: 0,
      listQuery: {
        page: 1,
        limit: 12
      },
      dataList: [],
      articleDetail: ""
    };
  },
  components: {
    secBanner,
    Pagination
  },
  watch: {
    $route(to, from) {
      this.activeIndex = this.$route.query.tab;
      if (this.activeIndex < 2) {
        this.getArcticleDetail();
      } else {
        this.getArticle();
      }
    }
  },
  mounted() {
    if (this.activeIndex < 2) {
      this.getArcticleDetail();
    } else {
      this.getArticle();
    }
  },
  computed: {
    srcList() {
      let imgSrcs = [];
      for (var i = 0; i < this.dataList.length; i++) {
        imgSrcs.push(this.$imgBaseUrl + this.dataList[i].article_img);
      }
      return imgSrcs;
    }
  },
  methods: {
    changeTab(index) {
      this.activeIndex = index;
      if (this.activeIndex < 2) {
        this.getArcticleDetail();
      } else {
        this.getArticle();
      }
    },
    getArcticleDetail() {
      this.$https
        .fetchPost("/Article/article_detail", {
          id: this.activeIndex > 0 ? 218 : 217
        })
        .then(res => {
          this.articleDetail = res.data.content;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getArticle() {
      this.$https
        .fetchPost("/Article/article_list", {
          classifyid: 44,
          page: this.listQuery.page,
          limit: this.listQuery.limit
        })
        .then(res => {
          // console.log(res.data)
          this.dataList = res.data;
          this.total = res.count;
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style lang="less">
.Aboutus-area {
  .honor {
    li {
      display: inline-block;
      width: 280px;
      height: 280px;
      background-color: rgba(255, 255, 255, 1);
      border: solid 1px rgba(238, 238, 238, 1);
      margin-bottom: 20px;
      &:not(:nth-child(4n)) {
        margin-right: 20px;
      }
      .img {
        padding: 15px;
        width: 280px;
        height: 245px;
        overflow: hidden;
      }
      .title {
        padding: 0 10px 10px;
        text-align: center;
        font-family: MicrosoftYaHei;
        font-size: 14px;
        line-height: 20px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: rgba(51, 51, 51, 1);
      }
    }
  }
}
.el-icon-circle-close {
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/Aboutus.vue